import type { IBrandQuoteThemeConfig } from "@/@sdk/brands/brand-model";
import type { iHolidayQuoteX } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import type { BrandContextType } from "../contexts/holiday-quote-brand-context";
import { resolveQuoteTheme } from "./resolve-quote-theme";

export interface BuildQuoteBrandContextInput {
  logo: BrandContextType["logo"];
  companyName: string;
  brandPrimaryColor?: string;
  quoteThemeConfig?: IBrandQuoteThemeConfig | null;
  quote: iHolidayQuoteX;
  quotesDomain: string;
  quoteLegalConfig?: BrandContextType["quoteLegalConfig"];
  currentAgent?: BrandContextType["currentAgent"];
  isAdminMode?: boolean;
  footerConfig?: BrandContextType["footerConfig"];
}

export function buildQuoteBrandContextValue(
  input: BuildQuoteBrandContextInput
): BrandContextType {
  const quoteTheme = resolveQuoteTheme({
    config: input.quoteThemeConfig,
    brandPrimaryColor: input.brandPrimaryColor,
    overridePrimaryColor: input.quote.data?.overridePrimaryColor,
    quoteOverrides: {
      primaryColorFillMode: input.quote.data?.primaryColorFillMode,
      navBarTemplate: input.quote.data?.navBarTemplate,
      headerTemplate: input.quote.data?.headerTemplate,
    },
  });

  return {
    logo: input.logo,
    companyName: input.companyName,
    primaryColor: quoteTheme.tokens.primary,
    currentAgent: input.currentAgent,
    quotesDomain: input.quotesDomain,
    quote: input.quote,
    quoteLegalConfig: input.quoteLegalConfig,
    isAdminMode: input.isAdminMode,
    footerConfig: input.footerConfig,
    headerTemplate: quoteTheme.headerTemplate,
    primaryColorFillMode: quoteTheme.primaryColorFillMode,
    navBarTemplate: quoteTheme.navBarTemplate,
    quoteTheme,
  };
}
